import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

* {
  box-sizing: border-box;
}

.profile-page {
  --archive-ink: #173b36;
  --archive-green: #2f625a;
  --archive-copper: #a5632f;
  --archive-paper: #f6f7f5;
  min-height: 100%;
  color: #0f172a;
  background: radial-gradient(circle at 12% 4%, rgba(47, 98, 90, 0.055), transparent 25rem), linear-gradient(180deg, #f8f9f7 0, var(--archive-paper) 36rem, #f3f5f4 100%);
  font-family: Pretendard, "Noto Sans KR", "Apple SD Gothic Neo", system-ui, sans-serif;
  font-size: 13px;
}

.library-container {
  width: min(100%, 1340px);
  margin-inline: auto;
}

button, input, select, textarea {
  font: inherit;
}

button:not(:disabled), select {
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
}

button:focus-visible, a:focus-visible {
  outline: 2px solid var(--archive-green);
  outline-offset: 3px;
}

/* /home과 동일한 자료함 헤더 */
.library-header {
  position: sticky;
  top: 0;
  z-index: 40;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(14px);
}

.header-inner {
  height: 78px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.library-logo-lockup {
  min-width: 0;
  display: flex;
  align-items: center;
  border-radius: 10px;
  text-decoration: none;
}

.library-logo-lockup img {
  width: auto;
  height: 48px;
  object-fit: contain;
}

.logo-divider {
  width: 1px;
  height: 28px;
  margin: 0 16px;
  background: #e2e8f0;
}

.logo-copy > span, .logo-copy strong {
  display: block;
}

.logo-copy > span {
  color: var(--archive-copper);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.logo-copy strong {
  margin-top: 2px;
  color: #475569;
  font-size: 13px;
  font-weight: 800;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.primary-action {
  height: 40px;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  border-radius: 8px;
  background: linear-gradient(135deg, #2d5d55 0%, var(--archive-ink) 100%);
  box-shadow: 0 7px 18px rgba(23, 59, 54, 0.18);
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
  transition: box-shadow 180ms ease, transform 180ms ease;
}

.primary-action:hover {
  box-shadow: 0 9px 22px rgba(23, 59, 54, 0.25);
  transform: translateY(-1px);
}

.primary-action svg {
  width: 16px;
  height: 16px;
}

.account-menu-wrap {
  position: relative;
}

.account-trigger {
  height: 40px;
  max-width: 190px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #334155;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.045);
  font-size: 13px;
  font-weight: 800;
  transition: border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
}

.account-trigger:hover, .account-trigger[aria-expanded=true] {
  border-color: #b7c3c0;
  background: #fafcfb;
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.075);
}

.account-avatar {
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: #fff;
  border-radius: 50%;
  background: #244d47;
}

.account-avatar svg {
  width: 16px;
  height: 16px;
}

.account-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-menu-chevron {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  color: #94a3b8;
  transition: transform 200ms ease;
}

.account-menu-chevron.is-open {
  transform: rotate(180deg);
}

.account-dropdown-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 50;
  width: 192px;
  padding: 6px;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 20px 34px rgba(15, 23, 42, 0.15);
  transform: translateY(-8px) scale(0.98);
  transform-origin: top right;
  transition: opacity 200ms ease, transform 200ms cubic-bezier(0.22, 1, 0.36, 1), visibility 0s linear 200ms;
}

.account-dropdown-menu.is-open {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0) scale(1);
  transition-delay: 0s;
}

.account-dropdown-profile {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.account-dropdown-profile p {
  margin: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-dropdown-profile span {
  display: block;
  margin-top: 2px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
}

.account-dropdown-menu > a {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #334155;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

.account-dropdown-menu > a svg {
  width: 16px;
  height: 16px;
}

.account-dropdown-menu > a.is-current {
  margin-top: 4px;
  color: var(--archive-ink);
  background: #f1f6f4;
}

.account-dropdown-menu > a.logout-link {
  color: #e11d48;
}

.account-dropdown-menu > a:hover {
  background: #f8fafc;
}

.account-dropdown-menu > a.logout-link:hover {
  background: #fff1f2;
}

/* /home 검색 히어로와 동일한 페이지 안내 영역 */
.profile-intro {
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  background: linear-gradient(115deg, rgba(255, 255, 255, 0.93), rgba(244, 248, 246, 0.9)), repeating-linear-gradient(90deg, transparent 0, transparent 47px, rgba(47, 98, 90, 0.026) 48px);
}

.profile-intro-inner {
  min-height: 130px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.intro-eyebrow {
  margin: 0;
  color: var(--archive-copper);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.profile-intro h1 {
  margin: 5px 0 0;
  color: #020617;
  font-size: 24px;
  font-weight: 850;
  letter-spacing: -0.03em;
}

.profile-intro p:last-child {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 650;
}

.home-link {
  height: 38px;
  padding: 0 13px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #475569;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
}

.home-link:hover {
  color: var(--archive-ink);
  border-color: #9aafa9;
  background: #f7faf9;
}

.home-link svg {
  width: 15px;
  height: 15px;
}

.profile-shell {
  padding: 24px 24px 64px;
}

/* 계정 요약 */
.profile-hero {
  position: relative;
  overflow: hidden;
  border: 1px solid #dce4e1;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.045);
}

.hero-glow {
  display: none;
}

.hero-content {
  min-height: 150px;
  padding: 24px 26px;
  display: grid;
  grid-template-columns: auto minmax(220px, 1fr) auto;
  align-items: center;
  gap: 22px;
}

.avatar-wrap {
  position: relative;
}

.profile-avatar {
  width: 76px;
  height: 76px;
  display: grid;
  place-items: center;
  color: #fff;
  border-radius: 17px;
  background: linear-gradient(145deg, #2f625a, #173b36);
  box-shadow: 0 10px 22px rgba(23, 59, 54, 0.18);
  font-size: 27px;
  font-weight: 850;
}

.avatar-status {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 17px;
  height: 17px;
  border: 4px solid #fff;
  border-radius: 50%;
  background: #22c55e;
}

.hero-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.hero-identity h1 {
  margin: 0;
  color: #0f172a;
  font-size: 23px;
  font-weight: 850;
  letter-spacing: -0.03em;
}

.hero-identity > p {
  margin: 6px 0 11px;
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
}

.role-badge {
  padding: 5px 9px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #76502f;
  border: 1px solid #e8d8c8;
  border-radius: 999px;
  background: #f7f0e9;
  font-size: 10px;
  font-weight: 800;
}

.role-badge svg {
  width: 13px;
  height: 13px;
}

.identity-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.identity-meta > span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.identity-meta > span + span::before {
  width: 3px;
  height: 3px;
  margin-right: 3px;
  border-radius: 50%;
  background: #cbd5e1;
  content: "";
}

.meta-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
}

.hero-facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(115px, 1fr));
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8faf9;
}

.hero-fact {
  min-width: 126px;
  padding: 16px 17px;
}

.hero-fact + .hero-fact {
  border-left: 1px solid #e2e8f0;
}

.hero-fact span, .hero-fact strong {
  display: block;
}

.hero-fact span {
  margin-bottom: 5px;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 750;
}

.hero-fact strong {
  max-width: 150px;
  overflow: hidden;
  color: #334155;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-layout {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 286px minmax(0, 1fr);
  align-items: start;
  gap: 20px;
}

.section-navigation {
  position: sticky;
  top: 98px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.045);
}

.navigation-label {
  margin: 3px 8px 10px;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.navigation-item {
  width: 100%;
  min-height: 52px;
  padding: 8px 9px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #64748b;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  text-align: left;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.navigation-item:hover {
  color: #243d39;
  background: #f7f9f8;
}

.navigation-item.is-active {
  color: var(--archive-ink);
  border-color: #c7d9d4;
  background: #eef5f2;
}

.navigation-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: #52616f;
  border: 1px solid #dbe2e0;
  border-radius: 9px;
  background: #fff;
}

.navigation-icon svg {
  width: 16px;
  height: 16px;
}

.navigation-icon.is-ai {
  color: #8a572e;
  border-color: #eadbcd;
  background: #faf4ed;
}

.navigation-item strong, .navigation-item small {
  display: block;
}

.navigation-item strong {
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 800;
}

.navigation-item small {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 650;
}

.navigation-note {
  margin-top: 11px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #52616f;
  border: 1px solid #e3ebe8;
  border-radius: 10px;
  background: #f5f8f7;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.55;
}

.navigation-note svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  margin-top: 1px;
  color: var(--archive-green);
}

.navigation-note p {
  margin: 0;
}

.settings-content {
  min-width: 0;
  display: grid;
  gap: 20px;
}

.section-anchor {
  scroll-margin-top: 98px;
}

.settings-card {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.card-heading {
  min-height: 86px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #e8eeec;
}

.eyebrow {
  display: block;
  margin-bottom: 5px;
  color: var(--archive-copper);
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.16em;
}

.card-heading h2, .ai-card-heading h2 {
  margin: 0;
  color: #0f172a;
  font-size: 17px;
  font-weight: 850;
  letter-spacing: -0.02em;
}

.card-heading p, .ai-card-heading p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.55;
}

.heading-icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  color: var(--archive-green);
  border: 1px solid #d8e5e1;
  border-radius: 11px;
  background: #eef5f2;
}

.heading-icon.is-security {
  color: #52616f;
  background: #f1f5f4;
}

.heading-icon svg {
  width: 19px;
  height: 19px;
}

.card-body {
  padding: 24px;
}

.info-banner {
  margin-bottom: 22px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 13px;
  border: 1px solid #dce8e4;
  border-radius: 12px;
  background: #f5f8f7;
}

.info-banner-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: #fff;
  border-radius: 10px;
  background: var(--archive-green);
  font-weight: 850;
}

.info-banner div {
  min-width: 0;
  flex: 1;
}

.info-banner strong, .info-banner p {
  display: block;
}

.info-banner strong {
  margin-bottom: 3px;
  color: #1e293b;
  font-size: 12px;
  font-weight: 800;
}

.info-banner p {
  margin: 0;
  color: #64748b;
  font-size: 10px;
  font-weight: 650;
}

.status-chip {
  padding: 5px 9px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #15803d;
  border: 1px solid #dcfce7;
  border-radius: 999px;
  background: #f0fdf4;
  font-size: 9px;
  font-weight: 800;
}

.status-chip span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #22c55e;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 20px;
}

.form-field {
  min-width: 0;
}

.form-field label, .label-row label {
  display: block;
  margin-bottom: 7px;
  color: #334155;
  font-size: 11px;
  font-weight: 800;
}

.form-field > small {
  display: block;
  margin-top: 6px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 650;
  line-height: 1.45;
}

.form-field > input, .form-field select, .password-input input, .threshold-control input {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  color: #1e293b;
  border: 1px solid #d7dfdd;
  border-radius: 9px;
  outline: none;
  background: #fff;
  font-size: 12px;
  font-weight: 650;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-field > input:focus, .form-field select:focus, .password-input input:focus, .threshold-control input:focus, .prompt-field textarea:focus {
  border-color: var(--archive-green);
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.09);
}

.form-field select {
  appearance: none;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' stroke='%2364758b' stroke-width='1.8'%3E%3Cpath d='m3 5 4 4 4-4'/%3E%3C/svg%3E") no-repeat right 12px center;
}

.input-with-icon {
  position: relative;
}

.input-with-icon svg {
  position: absolute;
  top: 13px;
  left: 12px;
  width: 16px;
  height: 16px;
  color: #94a3b8;
}

.input-with-icon input {
  width: 100%;
  height: 42px;
  padding: 0 12px 0 38px;
  color: #64748b;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #f8fafc;
}

.card-footer {
  min-height: 64px;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid #e8eeec;
  background: #fafcfb;
}

.card-footer p {
  margin: 0;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 650;
}

.primary-button, .secondary-primary-button, .ai-save-button, .ghost-button {
  min-height: 38px;
  padding: 0 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 800;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.primary-button, .secondary-primary-button, .ai-save-button {
  color: #fff;
  border: 1px solid var(--archive-ink);
  background: var(--archive-ink);
  box-shadow: 0 6px 14px rgba(23, 59, 54, 0.16);
}

.primary-button:hover:not(:disabled), .secondary-primary-button:hover:not(:disabled), .ai-save-button:hover:not(:disabled) {
  background: #0e2c28;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(23, 59, 54, 0.2);
}

.primary-button svg, .secondary-primary-button svg, .ai-save-button svg {
  width: 14px;
  height: 14px;
}

.primary-button:disabled, .secondary-primary-button:disabled, .ai-save-button:disabled, .ghost-button:disabled {
  opacity: 0.45;
}

.button-spinner {
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.security-body {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(220px, 0.75fr);
  gap: 28px;
}

.security-form {
  display: grid;
  gap: 18px;
}

.password-input {
  position: relative;
}

.password-input input {
  padding-right: 43px;
}

.password-input button {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  color: #94a3b8;
  border: 0;
  border-radius: 8px;
  background: transparent;
}

.password-input button:hover {
  color: var(--archive-green);
  background: #eef5f2;
}

.password-input svg {
  width: 16px;
  height: 16px;
}

.strength-meter {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.strength-bars {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
}

.strength-bars span {
  height: 3px;
  border-radius: 999px;
  background: #e2e8f0;
}

.strength-bars span.is-filled {
  background: var(--archive-green);
}

.strength-meter strong {
  min-width: 64px;
  color: #94a3b8;
  font-size: 9px;
  text-align: right;
}

.strength-meter strong[data-score="1"] {
  color: #dc2626;
}

.strength-meter strong[data-score="2"] {
  color: #b45309;
}

.strength-meter strong[data-score="3"], .strength-meter strong[data-score="4"] {
  color: #15803d;
}

.security-guide {
  padding: 20px;
  align-self: stretch;
  border: 1px solid #dfe7e4;
  border-radius: 12px;
  background: #f8faf9;
}

.guide-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  color: var(--archive-green);
  border-radius: 10px;
  background: #e8f1ee;
}

.guide-icon svg {
  width: 19px;
  height: 19px;
}

.security-guide h3 {
  margin: 15px 0 12px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.security-guide ul {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 9px;
  list-style: none;
}

.security-guide li {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 10px;
  font-weight: 650;
}

.security-guide li span {
  width: 15px;
  height: 15px;
  display: grid;
  place-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 50%;
  background: #fff;
}

.security-guide li.is-valid {
  color: #15803d;
}

.security-guide li.is-valid span {
  border-color: #86efac;
  background: #dcfce7;
}

.security-guide li.is-valid span::after {
  color: #16a34a;
  font-size: 9px;
  font-weight: 850;
  content: "✓";
}

.security-guide > p {
  margin: 16px 0 0;
  padding-top: 13px;
  color: #94a3b8;
  border-top: 1px solid #e2e8f0;
  font-size: 9px;
  font-weight: 650;
  line-height: 1.5;
}

/* 관리자 AI 설정도 자료함의 녹색/구리색 체계로 통일 */
.ai-settings-card {
  border-color: #d9e5e1;
}

.ai-card-heading {
  padding: 22px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #dfe8e5;
  background: linear-gradient(105deg, #f4f8f6, #fff 68%);
}

.ai-heading-main {
  display: flex;
  align-items: center;
  gap: 14px;
}

.ai-heading-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: #fff;
  border-radius: 12px;
  background: linear-gradient(145deg, #396d64, #173b36);
  box-shadow: 0 8px 18px rgba(23, 59, 54, 0.18);
}

.ai-heading-icon svg {
  width: 21px;
  height: 21px;
}

.ai-heading-badges {
  display: flex;
  align-items: center;
  gap: 7px;
}

.admin-only-badge, .unsaved-badge, .parameter-pill {
  padding: 5px 8px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.02em;
}

.admin-only-badge {
  color: #76502f;
  border: 1px solid #e8d8c8;
  background: #f8f0e8;
}

.unsaved-badge {
  color: #b45309;
  border: 1px solid #fde68a;
  background: #fffbeb;
}

.parameter-pill {
  color: #15803d;
  border: 1px solid #dcfce7;
  background: #f0fdf4;
  letter-spacing: 0.08em;
}

.ai-summary-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-bottom: 1px solid #e2e8f0;
  background: #fafcfb;
}

.ai-summary-strip > div {
  padding: 14px 24px;
}

.ai-summary-strip > div + div {
  border-left: 1px solid #e2e8f0;
}

.ai-summary-strip span, .ai-summary-strip strong {
  display: block;
}

.ai-summary-strip > div > span {
  margin-bottom: 4px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.ai-summary-strip strong {
  overflow: hidden;
  color: #334155;
  font-size: 10px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.connection-dot {
  display: inline-block !important;
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
  background: #22c55e;
}

.ai-tabs {
  padding: 14px 24px 0;
  display: flex;
  gap: 5px;
  border-bottom: 1px solid #e2e8f0;
}

.ai-tabs button {
  padding: 10px 13px 12px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #64748b;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  font-size: 11px;
  font-weight: 800;
}

.ai-tabs button:hover {
  color: var(--archive-green);
}

.ai-tabs button.is-active {
  color: var(--archive-ink);
  border-bottom-color: var(--archive-green);
}

.ai-tabs svg {
  width: 15px;
  height: 15px;
}

.ai-panel {
  padding: 26px 24px 28px;
}

.panel-section-heading {
  margin-bottom: 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
}

.panel-section-heading h3 {
  margin: 0;
  color: #1e293b;
  font-size: 13px;
  font-weight: 850;
}

.panel-section-heading p {
  margin: 5px 0 0;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.45;
}

.panel-divider {
  height: 1px;
  margin: 27px 0 23px;
  background: #e8eeec;
}

.ai-form-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.form-span-2 {
  grid-column: span 2;
}

.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.value-chip {
  padding: 3px 7px;
  color: var(--archive-green);
  border-radius: 6px;
  background: #eaf3f0;
  font-size: 9px;
  font-weight: 850;
}

.temperature-field input[type=range] {
  width: 100%;
  height: 5px;
  padding: 0;
  appearance: none;
  border: 0;
  border-radius: 999px;
  outline: none;
  background: linear-gradient(90deg, var(--archive-green), #dce8e4);
}

.temperature-field input[type=range]::-webkit-slider-thumb {
  width: 17px;
  height: 17px;
  appearance: none;
  border: 3px solid #fff;
  border-radius: 50%;
  background: var(--archive-green);
  box-shadow: 0 1px 5px rgba(23, 59, 54, 0.35);
}

.range-labels {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  color: #94a3b8;
  font-size: 8px;
  font-weight: 650;
}

.threshold-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.threshold-control {
  padding: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #dfe7e4;
  border-radius: 10px;
  background: #fafcfb;
}

.threshold-control > span {
  min-width: 0;
  flex: 1;
}

.threshold-control strong, .threshold-control small {
  display: block;
}

.threshold-control strong {
  margin-bottom: 3px;
  color: #334155;
  font-size: 10px;
  font-weight: 800;
}

.threshold-control small {
  overflow: hidden;
  color: #94a3b8;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.threshold-control input {
  width: 58px;
  height: 32px;
  padding: 0 5px;
  text-align: center;
  font-size: 10px;
}

.option-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.toggle-card {
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #dfe7e4;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.toggle-card:hover {
  background: #fafcfb;
}

.toggle-card > span {
  min-width: 0;
  flex: 1;
}

.toggle-card strong, .toggle-card small {
  display: block;
}

.toggle-card strong {
  margin-bottom: 4px;
  color: #334155;
  font-size: 10px;
  font-weight: 800;
}

.toggle-card small {
  color: #94a3b8;
  font-size: 8px;
  line-height: 1.4;
}

.toggle-card input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-card i {
  position: relative;
  width: 32px;
  height: 18px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #cbd5e1;
  transition: 0.18s;
}

.toggle-card i::after {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  transition: 0.18s;
  content: "";
}

.toggle-card input:checked + i {
  background: var(--archive-green);
}

.toggle-card input:checked + i::after {
  transform: translateX(14px);
}

.compact-form-grid {
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 15px;
}

.prompt-safety-banner {
  margin-bottom: 20px;
  padding: 14px 16px;
  display: flex;
  align-items: flex-start;
  gap: 11px;
  color: var(--archive-ink);
  border: 1px solid #d8e5e1;
  border-radius: 11px;
  background: #eef5f2;
}

.prompt-safety-banner svg {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}

.prompt-safety-banner strong, .prompt-safety-banner p {
  display: block;
}

.prompt-safety-banner strong {
  margin-bottom: 3px;
  font-size: 10px;
  font-weight: 850;
}

.prompt-safety-banner p {
  margin: 0;
  color: #52616f;
  font-size: 9px;
  font-weight: 650;
  line-height: 1.45;
}

.prompt-list {
  display: grid;
  gap: 16px;
}

.prompt-field {
  padding: 16px;
  border: 1px solid #dfe7e4;
  border-radius: 11px;
  background: #fafcfb;
}

.prompt-label {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.prompt-label label, .prompt-label span {
  display: block;
}

.prompt-label label {
  margin-bottom: 4px;
  color: #334155;
  font-size: 11px;
  font-weight: 850;
}

.prompt-label div > span {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 650;
}

.prompt-label > span {
  color: #94a3b8;
  font-size: 8px;
  white-space: nowrap;
}

.prompt-field textarea {
  width: 100%;
  min-height: 108px;
  padding: 12px;
  resize: vertical;
  color: #334155;
  border: 1px solid #d7dfdd;
  border-radius: 9px;
  outline: none;
  background: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.65;
}

.ai-card-footer {
  min-height: 72px;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid #dfe8e5;
  background: #fafcfb;
}

.ai-save-note {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 9px;
  font-weight: 650;
}

.ai-save-note svg {
  width: 15px;
  height: 15px;
  color: var(--archive-green);
}

.ai-footer-actions {
  display: flex;
  gap: 8px;
}

.ghost-button {
  color: #475569;
  border: 1px solid #d7dfdd;
  background: #fff;
}

.ghost-button:hover:not(:disabled) {
  color: var(--archive-ink);
  border-color: #aebfba;
  background: #f7faf9;
}

.page-footer {
  padding-top: 26px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 650;
  text-align: center;
}

.page-footer p {
  margin: 0;
}

@media (max-width: 1100px) {
  .hero-content {
    grid-template-columns: auto 1fr;
  }
  .hero-facts {
    grid-column: 1/-1;
    width: 100%;
  }
  .hero-fact {
    min-width: 0;
  }
  .threshold-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 900px) {
  .profile-layout {
    grid-template-columns: 1fr;
  }
  .section-navigation {
    position: sticky;
    top: 78px;
    z-index: 20;
    display: flex;
    gap: 5px;
    overflow-x: auto;
  }
  .navigation-label, .navigation-note {
    display: none;
  }
  .navigation-item {
    min-width: max-content;
    width: auto;
  }
  .navigation-item small {
    display: none;
  }
  .navigation-icon {
    width: 28px;
    height: 28px;
  }
  .security-body {
    grid-template-columns: 1fr;
  }
  .ai-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .option-grid {
    grid-template-columns: 1fr;
  }
  .ai-card-heading, .ai-card-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .ai-card-footer {
    align-items: stretch;
  }
  .ai-footer-actions {
    justify-content: flex-end;
  }
}
@media (max-width: 767px) {
  .primary-action {
    display: none;
  }
  .logo-copy, .logo-divider {
    display: none;
  }
}
@media (max-width: 639px) {
  .library-header {
    position: relative;
  }
  .header-inner {
    height: 70px;
    padding: 0 16px;
  }
  .library-logo-lockup img {
    height: 42px;
  }
  .account-name, .account-menu-chevron {
    display: none;
  }
  .account-trigger {
    width: 42px;
    padding: 0;
  }
  .profile-intro-inner {
    min-height: 124px;
    padding: 22px 18px;
  }
  .profile-intro h1 {
    font-size: 21px;
  }
  .profile-intro p:last-child {
    font-size: 12px;
  }
  .home-link span {
    display: none;
  }
  .home-link {
    width: 38px;
    padding: 0;
    justify-content: center;
  }
  .profile-shell {
    padding: 18px 16px 48px;
  }
  .profile-hero {
    border-radius: 14px;
  }
  .hero-content {
    padding: 22px 18px;
    grid-template-columns: 1fr;
    text-align: center;
  }
  .avatar-wrap {
    margin: 0 auto;
  }
  .hero-title-row, .identity-meta {
    justify-content: center;
  }
  .hero-facts {
    grid-template-columns: 1fr;
    text-align: left;
  }
  .hero-fact + .hero-fact {
    border-top: 1px solid #e2e8f0;
    border-left: 0;
  }
  .section-navigation {
    top: 0;
  }
  .card-heading, .card-body, .ai-card-heading, .ai-panel {
    padding-left: 18px;
    padding-right: 18px;
  }
  .form-grid, .ai-form-grid, .threshold-grid, .compact-form-grid {
    grid-template-columns: 1fr;
  }
  .form-span-2 {
    grid-column: span 1;
  }
  .card-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .card-footer p {
    text-align: center;
  }
  .primary-button, .secondary-primary-button {
    width: 100%;
  }
  .ai-summary-strip {
    grid-template-columns: 1fr;
  }
  .ai-summary-strip > div + div {
    border-top: 1px solid #e2e8f0;
    border-left: 0;
  }
  .ai-tabs {
    overflow-x: auto;
  }
  .ai-tabs button {
    min-width: max-content;
  }
  .ai-heading-badges {
    display: none;
  }
  .ai-heading-icon {
    width: 41px;
    height: 41px;
  }
  .ai-footer-actions {
    display: grid;
    grid-template-columns: 1fr 1.4fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .primary-action, .account-menu-chevron, .account-dropdown-menu, .primary-button,
  .secondary-primary-button, .ai-save-button {
    transition-duration: 0.01ms;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public activeSection: string = 'profile';
    public activeAITab: string = 'model';
    public saving: boolean = false;
    public changingPassword: boolean = false;
    public savingAI: boolean = false;
    public showCurrentPassword: boolean = false;
    public showNewPassword: boolean = false;
    public showConfirmPassword: boolean = false;
    public aiSettings: any = null;
    public savedAISettings: any = null;
    public accountMenuOpen: boolean = false;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data;
            if (data.ai_settings_admin && data.ai_settings) {
                this.aiSettings = this.clone(data.ai_settings);
                this.savedAISettings = this.clone(data.ai_settings);
            }
        } else {
            await this.service.modal.error(this.errorMessage(data, "프로필 정보를 불러오지 못했습니다."));
        }
        await this.service.render();
    }

    public isAdmin() {
        return !!this.user && this.user.role === 'admin';
    }

    public initials() {
        const value = (this.user && (this.user.name || this.user.id || this.user.email)) || '?';
        return String(value).trim().charAt(0).toUpperCase() || '?';
    }

    public roleLabel() {
        return this.isAdmin() ? '시스템 관리자' : '일반 사용자';
    }

    public statusLabel() {
        return this.user && this.user.status === 'active' ? '정상 사용 중' : '사용 제한';
    }

    public formatDate(value: any, empty: string = '기록 없음') {
        if (!value) return empty;
        const text = String(value).replace('T', ' ').split('.')[0];
        return text.length >= 16 ? text.slice(0, 16) : text;
    }

    public async selectSection(section: string) {
        this.activeSection = section;
        const target = document.getElementById(section);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        await this.service.render();
    }

    public async setAITab(tab: string) {
        this.activeAITab = tab;
        await this.service.render();
    }

    public accountDisplayName() {
        if (!this.user) return 'User';
        return this.user.name || this.user.id || this.user.email || 'User';
    }

    public async toggleAccountMenu() {
        this.accountMenuOpen = !this.accountMenuOpen;
        await this.service.render();
    }

    public async closeAccountMenu() {
        this.accountMenuOpen = false;
        await this.service.render();
    }

    @HostListener('document:click')
    public async closeAccountMenuOnOutsideClick() {
        if (!this.accountMenuOpen) return;
        await this.closeAccountMenu();
    }

    public async updateProfile() {
        const name = String(this.user.name || '').trim();
        const mobile = String(this.user.mobile || '').trim();
        if (!name) {
            await this.service.modal.error("이름을 입력해주세요.");
            return;
        }
        if (name.length > 50) {
            await this.service.modal.error("이름은 50자 이하로 입력해주세요.");
            return;
        }
        if (mobile.length > 20) {
            await this.service.modal.error("연락처는 20자 이하로 입력해주세요.");
            return;
        }

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call("update_profile", { name, mobile });
        this.saving = false;

        if (code === 200) {
            this.user.name = name;
            this.user.mobile = mobile;
            await this.service.modal.success("프로필 정보를 저장했습니다.");
        } else {
            await this.service.modal.error(this.errorMessage(data, "프로필 저장에 실패했습니다."));
        }
        await this.service.render();
    }

    public passwordScore() {
        const password = this.passwordForm.new_password || '';
        let score = 0;
        if (password.length >= 8) score += 1;
        if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
        if (/\d/.test(password)) score += 1;
        if (/[^A-Za-z0-9]/.test(password)) score += 1;
        return score;
    }

    public passwordStrengthLabel() {
        const labels = ['비밀번호를 입력하세요', '취약', '보통', '안전', '매우 안전'];
        return labels[this.passwordScore()];
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;
        if (!current_password) {
            await this.service.modal.error("현재 비밀번호를 입력해주세요.");
            return;
        }
        if (!new_password || new_password.length < 8) {
            await this.service.modal.error("새 비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error("새 비밀번호가 일치하지 않습니다.");
            return;
        }
        if (current_password === new_password) {
            await this.service.modal.error("현재 비밀번호와 다른 비밀번호를 사용해주세요.");
            return;
        }

        this.changingPassword = true;
        await this.service.render();
        const { code, data } = await wiz.call("change_password", {
            current_password,
            new_password
        });
        this.changingPassword = false;

        if (code === 200) {
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
            await this.service.modal.success("비밀번호를 안전하게 변경했습니다.");
        } else {
            await this.service.modal.error(this.errorMessage(data, "비밀번호 변경에 실패했습니다."));
        }
        await this.service.render();
    }

    public async saveAISettings() {
        if (!this.isAdmin() || !this.aiSettings) return;
        const temperature = Number(this.aiSettings.temperature);
        const maxTokens = Number(this.aiSettings.max_output_tokens);
        if (!String(this.aiSettings.metadata_model || '').trim()) {
            await this.service.modal.error("메타데이터 모델을 입력해주세요.");
            return;
        }
        if (!Number.isFinite(temperature) || temperature < 0 || temperature > 2) {
            await this.service.modal.error("Temperature는 0~2 범위로 입력해주세요.");
            return;
        }
        if (!Number.isFinite(maxTokens) || maxTokens < 1000 || maxTokens > 30000) {
            await this.service.modal.error("최대 출력 토큰은 1,000~30,000 범위로 입력해주세요.");
            return;
        }

        this.savingAI = true;
        await this.service.render();
        const { code, data } = await wiz.call("save_ai_settings", {
            settings: JSON.stringify(this.aiSettings)
        });
        this.savingAI = false;

        if (code === 200) {
            this.aiSettings = this.clone((data && data.settings) || this.aiSettings);
            this.savedAISettings = this.clone(this.aiSettings);
            await this.service.modal.success("AI 운영 설정을 저장했습니다. 다음 분석부터 새 기준이 적용됩니다.");
        } else {
            await this.service.modal.error(this.errorMessage(data, "AI 설정 저장에 실패했습니다."));
        }
        await this.service.render();
    }

    public async resetAISettings() {
        if (!this.savedAISettings) return;
        if (!this.hasAIChanges()) return;
        const confirmed = await this.service.modal.show({
            title: '변경 내용 되돌리기',
            message: '저장하지 않은 AI 설정 변경을 모두 되돌릴까요?',
            action: '되돌리기',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        this.aiSettings = this.clone(this.savedAISettings);
        await this.service.render();
    }

    public hasAIChanges() {
        if (!this.aiSettings || !this.savedAISettings) return false;
        return JSON.stringify(this.aiSettings) !== JSON.stringify(this.savedAISettings);
    }

    public goHome() {
        this.service.href('/home');
    }

    public errorMessage(data: any, fallback: string) {
        if (data && typeof data === 'object' && data.message) return data.message;
        if (typeof data === 'string' && data) return data;
        return fallback;
    }

    private clone(value: any) {
        return JSON.parse(JSON.stringify(value));
    }
}

export default PageMypageComponent;